import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { Fetch } from "../../../shared/Fetch";
import { JVDate } from "../../../shared/JVDate";
import { ICompanyMastDropdown, IBranchMastDropdown, ITeamsDropdown } from "../../../models/IDropdown";
import { JVDropdown } from "../../../shared/JVDropdown";
import { useEffect, useState } from "react";
import { ILogin } from "../../../models/Login";
import { JVInput } from "../../../shared/JVInput";
import { Dropdown } from "primereact/dropdown";
import { format } from "date-fns";


export interface IRecRepFilter {
    fromDate?: Date | null,
    toDate?: Date | null,
    company_ID?: number | null,
    report_Type?: string | null,
    status?: string | null,
    consultant?: string | null
}

export const EmptyRecRepFilter: IRecRepFilter = {
    fromDate: null,
    toDate: null,
    company_ID: null,
    report_Type: "",
    status: null
}


interface Iprops {
    salEffFilter: IRecRepFilter,
    setSalEffFilter: (salEffFilter: IRecRepFilter) => void,
    onSearch: () => void;
}

export const Filter = (props: Iprops) => {
    const [companies, setCompanies] = useState<Array<any>>([]);
    const [selecteduser, setselectedUser] = useState<any | null>(null);
    const [user, setUser] = useState<Array<any>>();


    const { control, handleSubmit, reset, watch } = useForm<IRecRepFilter>({
        defaultValues: props.salEffFilter,
        shouldFocusError: false
    });

    const loadCompanies = async () => {
        const response = await Fetch("Dropdown/companyListForHRs", "GET", null, null, null);
        if (response) {
            const data: Array<any> = await response.json();
            data.unshift({ company_ID: null, company_Name: "-- SELECT --" });
            setCompanies(data);
        }
    };


    const loadUser = async () => {
        const response = await Fetch("Dropdown/getConsultantName", "GET", null, null, null);
        if (response) {
            const data: Array<any> = await response.json();
            const emptyData = {
                consultant_ID: 0,
                consultant_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setUser(data);
        }
    }

    const searchToDB = async (body: IRecRepFilter) => {
        let filterData: any = body;
        let emptyFilter: any = EmptyRecRepFilter;
        for (let key in filterData) {
            if (filterData[key] === "-- SELECT --" || filterData[key] === 0) {
                filterData[key] = emptyFilter[key];
            }
        }
        body = filterData;
        props.setSalEffFilter(body);
    }


    function onSubmit(data: IRecRepFilter) {
        if (data.fromDate === undefined || data.fromDate === null) {
            alert("From Date is required in Filter");
        } else if (data.toDate === undefined || data.toDate === null) {
            alert("To Date is required in Filter");
        } else if (data.toDate < data.fromDate) {
            alert("To Date can not be less than From Date in Filter");
        } else {
            data.consultant = selecteduser
            searchToDB(data);
            props.onSearch();
        }
    }

    useEffect(() => {
        loadUser();
        loadCompanies();
    }, []);

    const fromDate = watch("fromDate");

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            <JVDate maxDate={new Date} column={6} label="From Date" control={control} name="fromDate" />
            <JVDate minDate={fromDate || undefined} maxDate={new Date} column={6} label="To Date" control={control} name="toDate" />
            <div style={{ width: '20%', marginLeft: '10px' }} >
                <label className="" style={{ display: 'block', marginBottom: '8px' }}>Consultant Name</label>
                <Dropdown value={selecteduser} onChange={(e) => {
                    setselectedUser(e.value);
                }} options={user} optionLabel="consultant_Name" placeholder="Select Consultant" optionValue="consultant_ID"
                    filter className="w-full" />
            </div>
            <JVDropdown column={6} label="Company" control={control} name="company_ID" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />
            <div className="col-12 md:col-12" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", columnGap: "10px", marginTop: "10px" }}>
                <Button label="SEARCH" type="submit" />
                <Button className="p-button-outlined" label="CLEAR" type="button" onClick={() => { reset(EmptyRecRepFilter); setselectedUser(null); }} />
            </div>
        </form>
    );
}
